import { createContext } from 'react';
import { SubMenu } from 'shared/components/connected/goal-card-multi-select-context-menu/types';
import { Goal } from 'shared/types/goal';

export type Payload = { goals: Goal[]; initialActiveSubMenu?: SubMenu };
export type Position = { left: number; top: number };

type ContextMenuContextType = {
  payload?: Payload;
  position?: Position;
  open: (position?: Position, payload?: Payload) => void;
  close: () => void;
};

export const ContextMenuContext = createContext<ContextMenuContextType>({
  payload: undefined,
  position: undefined,
  open: () => {},
  close: () => {},
});
